import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { generateParams } from '@/helpers/functions';
import { QueryParamRecord } from '@/bundles/App/type';
import { Exercise } from '@/helpers/types';

export default class QuestionService {
  private readonly transport: HttpTransport;
  private readonly errorMapper: ErrorMapper;

  constructor(transport: HttpTransport, errorMapper: ErrorMapper) {
    this.transport = transport;
    this.errorMapper = errorMapper;
  }

  // TODO: prepare correct type
  async list(params: QueryParamRecord[]): Promise<any> {
    try {
      const paramsString = generateParams(params);
      return await this.transport.get(`/exercise/paginated-list${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async update(id: string, payload: Exercise): Promise<Exercise> {
    try {
      return await this.transport.patch(`/exercise/${ id }`, payload)
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async archive(id: string) {
    try {
      return await this.transport.patch(`/exercise/${ id }/archive`, {});
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async create(payload: Exercise): Promise<Exercise> {
    try {
      return await this.transport.post(`/exercise`, payload)
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
